<template>
  <v-app class="d-block">
    <BaseAlert />

    <Header />
    <NuxtPage />

    <GreenEarthFooter v-if="isGreenEarth" />
    <Footer v-else />

    <ContactUsDialog />
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const isGreenEarth = computed(() => route.path.includes("/green-earth"));
</script>